import React from 'react';
import classNames from 'classnames';
import styles from './Spinner.module.scss';

export const Spinner = ({
    spinnerSize = 'medium', overlaySize = 'auto',
    color = 'black', backgroundColor,
    className
}: Props) => {

    const overlayStyle = classNames(styles.container, className, styles[overlaySize], {
        [styles[backgroundColor!]]: backgroundColor
    });

    const spinnerStyle = classNames(styles.circle, styles[spinnerSize], styles[color]);

    return (
        <div className={overlayStyle}>
            <span className={spinnerStyle} />
        </div>
    );
};

type Props = {
    overlaySize: 'full' | 'auto';
    spinnerSize: 'medium' | 'small';
    className?: string;
    color?: 'black' | 'white';
    backgroundColor?: 'black' | 'white';
};